import type { MintDayOverride } from "./meme-calendar.overrides";

export const CUSTOM_SKIPPED_MINT_DAYS: readonly MintDayOverride[] = [];
